import React, { Component } from 'react'
import OwlCarousel from 'react-owl-carousel';
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Select from 'react-select';
import _ from "lodash";
import { Link } from 'react-router-dom';
import axios from 'axios';
import countryCode from "./country_code.json";
import alertPopUp from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content';
import { authService } from './auth';
import PersonaCountryUserListPopUp from './PersonaCountryUserListPopUp';
import uuid from 'react-uuid';
import CommonOurSolutionGrid from './CommonOurSolutionGrid';
import CleverTapUtils from './commons/CleverTapUtils';

const ErorrMsgPopUp = withReactContent(alertPopUp)

class TopPostBoxComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userData: authService.getUserDetailsFromLocalStorage(),
            categoryList: [],
            wouldLikeList: [],
            wouldLikeDataList: [],
            userSelectedChoiceData: {},
            category: {},
            wouldLike: {},
            personaDataList: [],
            countryDataList: [],
            errors: {},
            currentData: {}, 
            showModal: false
        }
        this.commonVideoGridId=uuid();
    }

    getCategoryDataList = () => {
        axios({
            url: `${process.env.REACT_APP_userServiceURL}/backend/post/login/enable-list-belong-category`,
            method: "GET",
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
        }).then((response) => {
            if (response && response.data && response.data.message === "Success!") {
                let data = response.data.body && response.data.body.map((item) => { return { "label": item?.title, "value": item?.id } });
                this.setState({
                    categoryList: data
                })
            }
        }).catch((error) => {
            console.log(error)
        });
    }

    getWouldLIkeDataList = (categoryId) => {
        axios({
            url: `${process.env.REACT_APP_userServiceURL}/backend/post/login/get-belong-data-category?categoryId=${categoryId}`,
            method: "GET",
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
        }).then((response) => {
            if (response && response.data && response.data.message === "Success!") {
                let data = response.data.body && response.data.body.map((item) => { return { "label": item?.title, "value": item?.id } });
                this.setState({
                    wouldLikeList: data,
                    wouldLikeDataList: response.data.body
                })
            }
        }).catch((error) => {
            console.log(error)
        });
    }

    onChangeCategoryWouldLikeData = (data, type) => {
        this.setState({
            [type]: data,
            userSelectedChoiceData: {}
        })
        if (type === "category") {
            this.setState({
                wouldLike: {},
                wouldLikeList: []
            })
            this.getWouldLIkeDataList(data?.value);
        }
    }

    onFocusOurSolution = () => {
        let solutionData = this.state.categoryList && this.state.categoryList.map((item) => item.label);
        CleverTapUtils.eventClick({"I am": solutionData.toString()}, "Find best fit solution") ;
    }

    validateForm = () => {
        let formIsValid = true;
        if (_.isEmpty(this.state.category) || _.isEmpty(this.state.wouldLike)) {
            formIsValid = false;
            ErorrMsgPopUp.fire({
                didOpen: () => {
                    ErorrMsgPopUp.clickConfirm();
                }
            }).then((result) => {
                return ErorrMsgPopUp.fire({
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    title: <><p>Please select {_.isEmpty(this.state.category) ? "category" : "would like"}</p></>,
                })
            })
        }
        return formIsValid;
    }

    onSubmit = (event) => {
        event.preventDefault();
        if (this.validateForm()) {
            let userSelectedChoiceData = this.state.wouldLikeDataList && this.state.wouldLikeDataList.find((data) => data.id === this.state.wouldLike?.value);
            this.setState({
                userSelectedChoiceData: userSelectedChoiceData
            })
            let postData = {
                belongDataId: this.state.wouldLike?.value,
                userId: this.state.userData.userId
            }
            axios({
                method: "POST",
                url: `${process.env.REACT_APP_userServiceURL}/backend/post/login/create/user/history`,
                data: postData,
                withCredentials: true,
            }).then((response) => {
                if (response && response.data && response.data.message === "Success!") {

                }
            }).catch((error) => {
                console.log(error);
            });
        }
    }

    fetchPersonaCountryData = () => {
        axios({
            method: "GET",
            url: `${process.env.REACT_APP_userServiceURL}/backend/post/login/persona-list`,
            withCredentials: true,
        }).then((response) => {
            if (response && response.data && response.data.message === "Success!") {
                let result = response?.data?.body?.length > 0 ? response.data.body[0] : [];
                if (result) {
                    let countryDataList = countryCode && countryCode.filter(data => result && result?.country.includes(data.Name));
                    this.setState({
                        personaDataList: result?.persona,
                        countryDataList: countryDataList && countryDataList.map((data) => { return { code: data?.Iso2?.toLowerCase(), name: data?.Name } })
                    })
                }
            }
        }).catch((error) => {
            console.log(error);
        });
    }

    onClickPersonaCountry = (data, type) => {
        this.setState({
            currentData: { "type": type, "value": data },
            showModal: true
        }, () => {
            CleverTapUtils.eventClick({}, type === "PERSONA" ? "Open Category members list" : "Meet Members from a specific Country");
            window.$("#personaCountryUserListPopUp").modal("show");
        })
    }

    closeUserPopUp = () => {
        this.setState({
            showModal: false
        })
        if(this.state.currentData.type === "PERSONA") {
            CleverTapUtils.eventClick({}, "Close Category Members List") ;
        }
        window.$("#personaCountryUserListPopUp").modal("hide");
    }

    componentDidMount() {
        this.fetchPersonaCountryData();
        this.getCategoryDataList();
    }

    render() {
        const { activeTab } = this.props;
        const { categoryList, category, wouldLike, wouldLikeList, userSelectedChoiceData, personaDataList, countryDataList, showModal, currentData } = this.state;
        return (<>
            <div className="toppostWTinn">

                {/* {activeTab === "top_1" &&
                    <>
                        {personaDataList && personaDataList.length > 0 && 
                            <div className="toppostStaticSec">
                                <h4>They Belong Here</h4>
                                <OwlCarousel
                                    id={"postBelongHere"}
                                    className={"postBelongHere"}
                                    autoWidth={true}
                                    margin={9}
                                    items={4}
                                    loop={false}
                                    rewind={true}
                                    nav={true}
                                    dots={false}
                                    navText={[
                                        "<i class='iArrow_Left'></i>",
                                        "<i class='iArrow_Right'></i>",
                                    ]}
                                    responsive={{ 0: { items: 2 }, 600: { items: 3 }, 1000: { items: 5 } }}
                                >
                                    {personaDataList && personaDataList.map((data) => {
                                        return (
                                            <div className="item" key={uuid()} onClick={() => this.onClickPersonaCountry(data, "PERSONA")} style={{cursor: "pointer"}}>{data}</div>
                                        )
                                    })}
                                </OwlCarousel>
                            </div>
                        }
                        <div className="toppostStaticSec">
                            <h4>Our Solutions
                                <p className="shdesc">Find the best fit for you</p>
                            </h4>
                            <div className="toppostSolution">
                                <form id="would-like-form" name ="would-like-form" className="postSolutionForm" onSubmit={this.onSubmit}>
                                    <div class="postSolutionFormCol">
                                        <label>I am</label>
                                        <Select
                                            placeholder={"Select..."}
                                            className={'react-selectbox'}
                                            classNamePrefix='react-select'
                                            name={"iam"}
                                            options={categoryList}
                                            value={!_.isEmpty(category) ? category : ""}
                                            onChange={(data) => this.onChangeCategoryWouldLikeData(data, "category")}
                                            onFocus={(event) => this.onFocusOurSolution(event)}
                                            blurInputOnSelect={false}
                                            styles={{
                                                option: (styles, { data, isDisabled, isFocused, isSelected }) => {
                                                    const color = '#cfe7c7';
                                                    return {
                                                        ...styles,
                                                        backgroundColor: isDisabled
                                                            ? null
                                                            : isSelected
                                                                ? '#cfe7c7'
                                                                : isFocused
                                                                    ? '#cfe7c7'
                                                                    : null,
                                                        color: isDisabled
                                                            ? '#ccc'
                                                            : isSelected
                                                                ? color > 2
                                                                    ? '#00374d'
                                                                    : '#00374d'
                                                                : data.color,
                                                        cursor: isDisabled ? 'not-allowed' : 'default',

                                                        ':active': {
                                                            ...styles[':active'],
                                                            backgroundColor: !isDisabled && (isSelected ? '#cfe7c7' : '#cfe7c7'),
                                                        },
                                                    };
                                                },
                                            }}
                                        />
                                        <em>,</em>
                                    </div>
                                    <div class="postSolutionFormCol">
                                        <label>I would like</label>
                                        <Select
                                            placeholder={"Select..."}
                                            className={'react-selectbox'}
                                            classNamePrefix='react-select'
                                            name={"iam"}
                                            options={wouldLikeList}
                                            value={!_.isEmpty(wouldLike) ? wouldLike : ""}
                                            onChange={(data) => this.onChangeCategoryWouldLikeData(data, "wouldLike")}
                                            blurInputOnSelect={false}
                                            styles={{
                                                option: (styles, { data, isDisabled, isFocused, isSelected }) => {
                                                    const color = '#cfe7c7';
                                                    return {
                                                        ...styles,
                                                        backgroundColor: isDisabled
                                                            ? null
                                                            : isSelected
                                                                ? '#cfe7c7'
                                                                : isFocused
                                                                    ? '#cfe7c7'
                                                                    : null,
                                                        color: isDisabled
                                                            ? '#ccc'
                                                            : isSelected
                                                                ? color > 2
                                                                    ? '#00374d'
                                                                    : '#00374d'
                                                                : data.color,
                                                        cursor: isDisabled ? 'not-allowed' : 'default',

                                                        ':active': {
                                                            ...styles[':active'],
                                                            backgroundColor: !isDisabled && (isSelected ? '#cfe7c7' : '#cfe7c7'),
                                                        },
                                                    };
                                                },
                                            }}
                                        />
                                    </div>
                                    <button className="btn submit" type="submit" disabled={!this.state.category?.value || !this.state.wouldLike?.value}>Submit</button>
                                </form>
                            </div>
                        </div>
                        <div className="toppostStaticSec">
                            <div className="toppostStoriesWrap">
                                {!_.isEmpty(userSelectedChoiceData) &&
                                    <div className={userSelectedChoiceData?.links?.length > 1 ? "toppostSolutionVideo mobfullWidth" : "toppostSolutionVideo"}>
                                        <div className="videoContainer">
                                            {userSelectedChoiceData?.links && userSelectedChoiceData?.links.map((data) => {
                                                return (
                                                    <CommonOurSolutionGrid videoLink={data} />
                                                )
                                            })}
                                        </div>
                                    </div>
                                }

                                {countryDataList?.length > 0 &&
                                    <div className={countryDataList?.length > 6 ? "toppostMeetMenber mobfullWidth" : "toppostMeetMenber"}>
                                        <h5>Meet Members from</h5>
                                        <div className="meetMemberFlags">
                                            {countryDataList && countryDataList.map((data) => {
                                                return (
                                                    <figure onClick={() => this.onClickPersonaCountry(data?.name, "COUNTRY")} style={{cursor: "pointer"}}><img src={`https://flagcdn.com/56x42/${data?.code}.png`} alt={data?.name} /></figure>
                                                )
                                            })}
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </>
                } */}

                <>
                    <h1><Link to="/explore-trending" onClick={() => {{CleverTapUtils.eventClick({}, "View Whats Trending");}}}>What's Trending</Link></h1>
                    <div className="popsharescreenlist">
                        <div className="popsharegrid">
                            <Link to={"/explore-trending/blogs"} onClick={() => {{CleverTapUtils.eventClick({}, "View Trending Articles");}}}>
                                <div className="icoblk">
                                    <i className="iBlog" />
                                </div>
                                <span>Articles</span>
                            </Link>
                        </div>
                        <div className="popsharegrid">
                            <Link to={"/explore-trending/photos"} onClick={() => {{CleverTapUtils.eventClick({}, "VIew Trending Photos");}}}>
                                <div className="icoblk">
                                    <i className="iPhotos" />
                                </div>
                                <span>Photos</span>
                            </Link>
                        </div>
                        <div className="popsharegrid">
                            <Link to={"/explore-trending/videos"} onClick={() => {{CleverTapUtils.eventClick({}, "View Trending Videos");}}}>
                                <div className="icoblk">
                                    <i className="iVideos" />
                                </div>
                                <span>Videos</span>
                            </Link>
                        </div>
                        <div className="popsharegrid">
                            <Link to={"/explore-hashtag"} onClick={() => {{CleverTapUtils.eventClick({}, "View Trending Hashtags");}}}>
                                <div className="icoblk">
                                    <i className="iHashtag" />
                                </div>
                                <span>Tags</span>
                            </Link>
                        </div>
                    </div>
                </>

            </div>

            {showModal && <PersonaCountryUserListPopUp currentData={currentData} closeUserPopUp={this.closeUserPopUp} />}
        </>
        )
    }
}

export default TopPostBoxComponent;
